import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors as configSelectors } from '../../infrastructure/config';
import SetUpInProgressPage from './SetUpInProgressPage';

class setUpInProgress extends Component {
  render() {
    const { bankId } = this.props;
    return <SetUpInProgressPage bankId={bankId} />;
  }
}

setUpInProgress.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: configSelectors.bankId(state)
});

export default connect(mapStateToProps)(setUpInProgress);
